import React, { memo, useMemo } from "react";
import { Position, useReactFlow } from "@xyflow/react";

import {
  DBSchemaNode,
  DBSchemaNodeHeader,
  DBSchemaNodeBody,
  DBSchemaTableRow,
  DBSchemaTableCell
} from "./DBSchemaNodes";
import LabeledHandle from "./LabelHandler";

const DBSchemaDashboard = memo(({ data, selected, id }) => {
  const { getEdges, getNode } = useReactFlow();
  const edges = getEdges();
  const currentNode = getNode(id);

  // Optimize connection lookup using a Map
  const handleConnections = useMemo(() => {
    const map = new Map();
    edges.forEach((edge) => {
      // Ignore self-referencing edges
      if (edge.source === edge.target) return;

      map.set(edge.sourceHandle, true);
      map.set(edge.targetHandle, true);
    });
    return map;
  }, [edges]);

  const isHandleConnected = (handleId) => handleConnections.has(handleId);

  return (
    <DBSchemaNode className="p-0" selected={selected}>
      <DBSchemaNodeHeader isView={currentNode.table_type === "VIEW"}>{data.label}</DBSchemaNodeHeader>
      <DBSchemaNodeBody>
        {data.schema.map((entry) => {
          const connectionStatus = isHandleConnected(entry.title);

          return (
            <DBSchemaTableRow key={entry.title}>
              <DBSchemaTableCell className="pl-2 pr-6 font_weight_normal">
                <LabeledHandle
                  id={entry.title}
                  title={entry.title}
                  type="source"
                  position={Position.Left}
                  isConnected={connectionStatus}
                />
              </DBSchemaTableCell>
              <DBSchemaTableCell className="pr-2 font_weight_light">
                <LabeledHandle
                  id={entry.title}
                  title={entry.type}
                  type="target"
                  position={Position.Right}
                  isConnected={connectionStatus}
                />
              </DBSchemaTableCell>
            </DBSchemaTableRow>
          );
        })}
      </DBSchemaNodeBody>
    </DBSchemaNode>
  );
});

export default DBSchemaDashboard;
